var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000.000000pt",
    height: "1000.000000pt",
    viewBox: "0 0 1000.000000 1000.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 5000 l0 -4100 3900 0 3900 0 0 2450 0 2450 -900 0 -900 0 0 1650 0 1650 -3000 0 -3000 0 0 -4100z m5600 0 l0 -3700 -2600 0 -2600 0 0 3700 0 3700 2600 0 2600 0 0 -3700z m1800 -1650 l0 -2050 -700 0 -700 0 0 2050 0 2050 700 0 700 0 0 -2050z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 7300 l0 -200 1000 0 1000 0 0 200 0 200 -1000 0 -1000 0 0 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 6200 l0 -200 1350 0 1350 0 0 200 0 200 -1350 0 -1350 0 0 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 5100 l0 -200 1650 0 1650 0 0 200 0 200 -1650 0 -1650 0 0 -200z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.7bca83a892acce3c4ac630dd91a6629d.svg";
export { ForwardRef as ReactComponent };